import { ArrowUp } from "@phosphor-icons/react";

const services = [
  "Diseño Web",
  "Posicionamiento SEO",
  "Redes Sociales",
  "Email Marketing",
  "Link Building",
  "Analíticas",
];

export default function Footer() {
  return (
    <footer
      id="nosotros"
      data-testid="site-footer"
      className="relative border-t border-white/15 bg-[#15318f] py-20 md:py-24 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto flex flex-col gap-16">
        {/* Top: Big logotype + services */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-7">
            <p className="font-display text-xs font-bold tracking-[0.25em] uppercase text-white/70 mb-4">
              / Agencia de Marketing Digital
            </p>
            <h2
              data-testid="footer-logotype"
              className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black tracking-tighter uppercase leading-[0.85]"
            >
              Te van a <br />
              <span className="text-volt">conocer.</span>
            </h2>
            <p className="mt-8 max-w-lg text-white/85 text-base leading-relaxed">
              Convertimos marcas anónimas en referentes. Estrategia, tecnología
              y creatividad al servicio de tu crecimiento.
            </p>
          </div>

          <div className="md:col-span-5">
            <p className="font-display text-[10px] font-bold tracking-[0.25em] uppercase text-white/65 mb-5">
              Servicios
            </p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {services.map((item) => (
                <li
                  key={item}
                  data-testid={`footer-service-${item.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/85"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="section-rule h-px w-full" />

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
          <p
            data-testid="footer-copyright"
            className="font-display text-[11px] font-bold tracking-[0.2em] uppercase text-white/65"
          >
            © 2026 Te Van A Conocer · Todos los derechos reservados
          </p>

          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="btn-ghost text-xs px-4 py-3"
          >
            Volver Arriba
            <ArrowUp size={14} weight="bold" />
          </button>
        </div>
      </div>
    </footer>
  );
}
